import {
    IConfigGeralVendas,
    IConfigGeralVendasPut,
} from "../../../Interfaces/Vendas/ConfigGeral/ConfigGeralInterface";
import AxiosVendas from "../../Config/ApiVendas";
import Service from "../../Service";

export async function ConfigGeralVendasGetService() {
    return Service(
        AxiosVendas.get<Array<IConfigGeralVendas>>(`/app/configgeral`)
    );
}

export async function ConfigGeralVendasPutService(
    requestBody: Array<IConfigGeralVendasPut>
) {
    return Service(AxiosVendas.put(`/app/configgeral`, requestBody));
}
